import store from '@/store';
export const option = {
    height: 'auto',
    calcHeight: 80,
    tip: false,
    delBtn: false,
    editBtn: false,
    addBtn: true,
    searchShow: true,
    searchMenuSpan: 6,
    searchLabelWidth: 100,
    labelWidth: 150,
    border: true,
    index: true,
    indexLabel: '序号',
    selection: false,
    viewBtn: false,
    dialogType: 'dialog',
    dialogClickModal: false,
    column: [{
            label: "所属类型",
            prop: "type",
            type: 'radio',
            search: true,
            span: 24,
            value: 0,
            dicData: [{
                    label: '钥匙',
                    value: 0
                },
                {
                    label: '登记证书',
                    value: 1
                }
            ],
            rules: [{
                required: true,
                message: "请选择所属类型",
                trigger: "change",
            }, ],
        },
        {
            label: "库位",
            prop: "storageLocation",
            type: "input",
            search: true,
            searchOrder: 100,
            span: 24,
            rules: [{
                required: true,
                message: "请输入库位名称",
                trigger: "blur",
            }, ],
        },

        {
            label: "备注",
            prop: "remark",
            type: "textarea",
            span: 24,
        },
        {
            label: "id",
            prop: "id",
            display: false,
            hide: true,
        },
        {
            label: "创建人",
            prop: "createUserName",
            display: false,
        },
        {
            label: "创建时间",
            prop: "createTime",
            span: 24,
            display: false,
        }
    ],
}
